import { createFileRoute } from "@tanstack/react-router";
import { m } from "~/lib/i18n";
import { landingStylesheet } from "~/features/landing/landing-styles";

export const Route = createFileRoute("/")({
  ssr: true,
  // Cacheable HTML must hydrate with its original year, even if the browser
  // opens that document after a UTC year boundary.
  loader: () => ({ copyrightYear: new Date().getUTCFullYear() }),
  head: () => ({
    links: [
      { rel: "stylesheet", href: landingStylesheet, id: "homepage-styles" },
    ],
    meta: [
      { title: m.landing_page_meta_title() },
      {
        content: m.landing_page_meta_description(),
        name: "description",
      },
    ],
  }),
});
